<template>
    <div>
        <app-page-header title="People" subtitle="Our people are our greatest asset. <br/>Message us and say hello." light-theme />
        <div class="executive-team">
            <b-container>
                 <h2>Executive Team</h2>
                 <b-row class="justify-content-md-center">
                    <b-col lg="6" v-for="person in management" :key="person.name" class="mb-5">
                        <executive-team-card :people="person" />
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="global_specialists">
            <b-container>
                <h2>Global Specialists</h2>
                <b-row class="align-items-center">
                    <b-col md="6" lg="4" v-for="person in specialists" :key="person.name" class="mb-4">
                        <people-card :people="person" />
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>
<script>
import PeopleData from '@/data/people.json';
import AppPageHeader from '@/components/global/AppPageHeader';
import PeopleCard from '@/components/people/PeopleCard';
import ExecutiveTeamCard from '@/components/people/ExecutiveTeamCard';

export default {
    name: 'people',
    components: {
        AppPageHeader,
        PeopleCard,
        ExecutiveTeamCard,
    },
    data() {
        return {
            people: PeopleData,
        };
    },
    computed: {
        management() {
            return this.people.filter(p => p.management);
        },
        specialists() {
            return this.people.filter(p => !p.management);
        },
    },
};
</script>

<style lang="scss" scoped>
h2 {
    text-align: center;
    font-size: 44px;
    font-weight: 900;
    color: #000112;
    margin-bottom: 40px;

    @include media-breakpoint-up(sm) {
        margin-bottom: 60px;
    }
}
.executive-team {
    background-color: #0B0124;
    color: #ffffff;
    padding: 80px 0 30px;

    h2 {
        color: #ffffff;
    }
}
.global_specialists {
    padding: 60px 0 120px;
}
</style>
